import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb78969"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray-200 min-h-screen" }
const _hoisted_2 = { class: "w-full fixed z-40" }
const _hoisted_3 = { class: "flex-1 flex flex-col" }
const _hoisted_4 = { class: "min-h-screen" }
const _hoisted_5 = { class: "bg-gray-800 text-white py-8" }
const _hoisted_6 = { class: "container mx-auto text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.digiapps.com.co/privacy-policy",
  target: "_blank"
}, "Privacy policy", -1))

import {
  computed,
  watch,
  defineAsyncComponent,
  ref,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const Sidebar = defineAsyncComponent(() => import('@/components/app/sidebar.vue'));
const Alerts = defineAsyncComponent(() => import('@/components/app/alerts.vue'));
const Menu = defineAsyncComponent(() => import('@/components/app/menu.vue'));

const store = useStore();
const route = useRoute();

const showSidebar = computed(() => store.getters.getShowSidebar);

const year = ref(new Date().getUTCFullYear());

const clickOutside = () => {
  if (showSidebar.value) store.commit('toggleSidebar');
};

const toggleSidebar = () => {
  store.commit('toggleSidebar');
};

watch(
  // on url change close sidebar
  () => route.path,
  () => {
    if (showSidebar.value) store.commit('toggleSidebar');
  },
);


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showSidebar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black opacity-50 z-30 lg:hidden",
          onClick: toggleSidebar,
          onKeydown: toggleSidebar
        }, null, 32))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_unref(Alerts)),
      _createVNode(_unref(Menu)),
      _createVNode(_unref(Sidebar))
    ])), [
      [_directive_click_outside, clickOutside]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        'h-screen overflow-y-auto pt-12 relative',
        { 'lg:pl-64': showSidebar.value },
      ])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ]),
        _createElementVNode("footer", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, "© " + _toDisplayString(year.value) + " digi subscriptions. All rights reserved.", 1),
            _hoisted_7
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})